import { animated, useSpring } from "react-spring";
import { bioPink } from "../../../constants/constants";
import { springConfigs } from "../../../constants/springConfigs";
import { useWindowSize } from "../../../hooks/useWindowSize";

const MenuSubText = ({ active, subText, bulletPoints }) => {
  const { opacity } = useSpring({
    from: { opacity: 0 },
    to: { opacity: active ? 1 : 0 },
    config: active
      ? {
          tension: 280,
          friction: 120,
          mass: 10,
        }
      : springConfigs.columnInactive,
  });
  const { subTextMarginTop } = useSpring({
    from: { subTextMarginTop: "24px" },
    to: { subTextMarginTop: active ? "-3px" : "24px" },
    config: active
      ? {
          tension: 280,
          friction: 120,
          mass: 10,
        }
      : springConfigs.columnInactive,
  });
  const { subTextSpacing } = useSpring({
    from: { subTextSpacing: "3px" },
    to: { subTextSpacing: active ? "0px" : "3px" },
    config: active
      ? {
          tension: 280,
          friction: 120,
          mass: 10,
        }
      : springConfigs.columnInactive,
  });

  const { mobileHorizontal, tabletHorizontal, h }: any = { ...useWindowSize() };

  return (
    <>
      <animated.div
        style={{
          paddingBottom: h(1.5),
          opacity,
          marginTop: subTextMarginTop,
          // lineHeight: "1.75em",
          // fontSize: mobileHorizontal || tabletHorizontal ? "2vh" : "0.75em",
          fontSize: h(2),
          lineHeight: mobileHorizontal || tabletHorizontal ? "" : "1.75em",
          fontWeight: 400,
        }}
      >
        {subText}
      </animated.div>
      <div
        style={{
          lineHeight: "1.75em",
          fontWeight: 400,
          paddingBottom: "2.25rem",
          paddingTop: "-0.75rem",
        }}
      >
        {bulletPoints.map((bulletPoint, i) => (
          <animated.div
            {...{
              key: i,
              style: {
                paddingTop: h(1),
                paddingBottom: h(0.5),
                display: "grid",
                gridTemplateColumns: "2% 98%",
                opacity,
                marginTop: subTextSpacing,
                alignItems: "center",
                fontSize: h(2),
                lineHeight:
                  mobileHorizontal || tabletHorizontal ? "" : "1.75em",
              },
            }}
          >
            <div
              style={{
                overflow: "hidden",
                height: h(0.6),
                marginTop: h(1.25),
                display: "flex",
                placeSelf: "start center",
              }}
            >
              <svg viewBox="-1 -1 102 102">
                <circle
                  cx="50"
                  cy="50"
                  r="50"
                  stroke={bioPink}
                  fill={bioPink}
                />
              </svg>
            </div>
            <div
              style={{
                lineHeight: "1.75em",
                fontWeight: 400,
                marginLeft: "0.75rem",
              }}
            >
              {bulletPoint}
            </div>
          </animated.div>
        ))}
      </div>
    </>
  );
};

export default MenuSubText;
